export const tireDispositionTabs: ITireDispositionTabs = {
  postOosTires: 'Post OOS Tires',
  postFlaggedAsDamaged: 'Post Flagged as Damaged',
  unflagConsignedTire: 'Unflag Consigned Tires',
  transferTires: 'Transfer Tires',
  tireDispositionQueue: 'Tire Optix Queue',
};

export interface ITireDispositionTabs {
    postFlaggedAsDamaged: string;
    postOosTires: string;
    unflagConsignedTire: string;
    transferTires: string;
    tireDispositionQueue: string;
}
